module.exports = __webpack_public_path__ + "img/1472945802.e433bf7d.jpg";